import React, { FC } from 'react';

import { DateTime } from 'luxon';

import { hockeyFormatter } from '@nhl/formatter-utilities';

import {
    franchiseSelectors,
    franchiseSeasonBySeasonInitialState,
    useFranchiseSeasonBySeasonRecordsQuery,
} from '../../../../../redux/ducks/franchises';
import { TeamDisplayModule } from '../../../../components';

import './styles.scss';

const FranchiseTombstone: FC = () => {
    const franchise = franchiseSelectors.getSelectedFranchise();
    const team = franchiseSelectors.getActiveTeam(franchise);

    const { data = franchiseSeasonBySeasonInitialState } = useFranchiseSeasonBySeasonRecordsQuery({
        franchiseId: franchise?.id,
        teamId: team?.id,
    });
    const { franchiseDetails } = data;
    const franchiseFormerTeams = (franchise) => {
        const firstYear = (team) => hockeyFormatter.seasonStartYearFormatter(team.franchiseTeam[0].firstSeason.id);
        const lastYear = (team) => hockeyFormatter.seasonEndYearFormatter(team.franchiseTeam[0].lastSeason.id);

        return franchise.teams
            .filter((team) => franchise.mostRecentTeamId !== team.id)
            .sort((a, b) => b.franchiseTeam[0].firstSeason.id - a.franchiseTeam[0].firstSeason.id)
            .map((team) => {
                return (
                    <TeamDisplayModule
                        key={team.id}
                        className="former-team"
                        team={team}
                        useInTable
                        append={<div className={'year-span'}>{`(${firstYear(team)}-${lastYear(team)})`}</div>}
                        displayNameOverride={team.fullName}
                    />
                );
            });
    };

    return franchiseDetails.dateAwarded ? (
        <div className="franchise-tombstone">
            <h1>{`${team.fullName}`}</h1>
            <h4 className="tombstone-info">
                <div>
                    {`Franchise Date: ${DateTime.fromISO(franchiseDetails.dateAwarded).toLocaleString(
                        DateTime.DATE_FULL
                    )}
                         | First NHL Season: ${hockeyFormatter.singleSeasonFormatter(franchiseDetails.firstSeasonId)}`}
                </div>
            </h4>
            {franchise.teams.length > 1 && (
                <div className="franchise-former-teams">{franchiseFormerTeams(franchise)}</div>
            )}
        </div>
    ) : null;
};

export default FranchiseTombstone;
